import type { FC } from "react";

import { CallToAction as UICallToAction } from "@jti/loyalty/components/CallToAction";

import type { callToActionInputs } from "./CallToAction.builder";

type CallToActionBuilderProps = BuilderComponentProps<typeof callToActionInputs>;

export const CallToAction: FC<CallToActionBuilderProps> = (props) => {
  return <UICallToAction {...props} />;
};
